<template>
  <div class="home-content">
    <template v-if="showList">
      <HomeList :section="listSection"
        :list-news="newsList" :list-culture="noticeList" :list-guide="industryList"
        :list-gov="govList" :list-consult="consultList" :list-scene="sceneList"
        @go-home="showList = false" @select-article="openArticleFromList" />
    </template>
    <template v-else-if="showDetail">
      <HomeDetail :article="currentArticle" :section="currentSection" :hide-sidebar="!currentSection"
        :list-news="newsList" :list-culture="noticeList" :list-guide="industryList"
        :list-gov="govList" :list-consult="consultList" :list-scene="sceneList"
        @go-home="showDetail = false" @go-list="backToList" @next-article="onNextArticle" />
    </template>
    <template v-else>
    <div class="carousel-section">
      <div class="carousel" v-if="carouselList.length">
        <div class="carousel-inner" @click="clickBanner">
          <img :src="carouselList[currentSlide].img" alt="">
          <div class="carousel-bar">
            <span class="carousel-title">{{ carouselList[currentSlide].title }}</span>
            <div class="carousel-dots" @mouseenter="stopAutoPlay" @mouseleave="startAutoPlay">
              <span
                v-for="(item, index) in carouselList"
                :key="index"
                class="dot"
                :class="{ active: currentSlide === index }"
                @click="currentSlide = index"
                @mouseenter="currentSlide = index"
              ></span>
            </div>
          </div>
        </div>
      </div>
      <div class="carousel-right">
        <div class="section">
          <div class="section-header" @click="openSection('景区动态')">
            <span class="section-title">景区动态</span>
            <span class="more-btn" @click.stop="openSection('景区动态')">更多 >></span>
          </div>
          <div class="news-featured" v-if="newsList.length" @click="goArticle('景区动态', newsList[0])">{{ newsList[0].title }}</div>
          <div class="news-list">
            <div
              v-for="(item, index) in newsList.slice(1)"
              :key="index"
              class="news-item"
               @click="goArticle('景区动态', item)"
            >
              <span class="news-dot"></span>
              <span class="news-title">{{ item.title }}</span>
              <span class="news-date">{{ item.date }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="thumb-row">
      <img v-for="(img, i) in thumbImages" :key="i" :src="img" alt="" class="thumb-img" :class="{ clickable: i >= 0 }" @click="thumbClick(i)">
    </div>
<div class="info-section">
      <div class="info-col">
        <div class="section">
          <div class="section-header" @click="openSection('政务公开')">
            <span class="section-title">政务公开</span>
            <span class="more-btn" @click.stop="openSection('政务公开')">更多 >></span>
          </div>
          <div class="news-list">
            <div
              v-for="(item, index) in govList"
              :key="index"
              class="news-item"
               @click="goArticle('政务公开', item)"
            >
              <span class="news-dot"></span>
              <span class="news-title">{{ item.title }}</span>
              <span class="news-date">{{ item.date }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="info-col">
        <div class="section">
          <div class="section-header" @click="openSection('政务信息')">
            <span class="section-title">政务信息</span>
            <span class="more-btn" @click.stop="openSection('政务信息')">更多 >></span>
          </div>
          <div class="news-list">
            <div
              v-for="(item, index) in consultList"
              :key="index"
              class="news-item"
              @click="goArticle('政务信息', item)"
            >
              <span class="news-dot"></span>
              <span class="news-title">{{ item.title }}</span>
              <span class="news-date">{{ item.date }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="info-section">
      <div class="info-col">
        <div class="section">
          <div class="section-header" @click="openSection('景区文化')">
            <span class="section-title">景区文化</span>
            <span class="more-btn" @click.stop="openSection('景区文化')">更多 >></span>
          </div>
          <div class="news-list">
            <div
              v-for="(item, index) in noticeList"
              :key="index"
              class="news-item"
               @click="goArticle('景区文化', item)"
            >
              <span class="news-dot"></span>
              <span class="news-title">{{ item.title }}</span>
              <span class="news-date">{{ item.date }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="info-col">
        <div class="section">
          <div class="section-header" @click="openSection('旅游攻略')">
            <span class="section-title">旅游攻略</span>
            <span class="more-btn" @click.stop="openSection('旅游攻略')">更多 >></span>
          </div>
          <div class="news-list">
            <div
              v-for="(item, index) in industryList"
              :key="index"
              class="news-item"
               @click="goArticle('旅游攻略', item)"
            >
              <span class="news-dot"></span>
              <span class="news-title">{{ item.title }}</span>
              <span class="news-date">{{ item.date }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SceneSection @select-scene="goArticle('景区风光', $event)" @more-click="openSection('景区风光')" />
    </template>
  </div>
</template>

<script>
import { getHomePage, getArticleDetail } from '../api/index'
import thumbImg from '../assets/imgs/ceshi.png'
import thumbImg1 from '../assets/imgs/321.png'
import thumbImg2 from '../assets/imgs/123.png'
import thumbImg3 from '../assets/imgs/-h-组 32.png'
import thumbImg4 from '../assets/imgs/-h-组 33.png'
import SceneSection from './SceneSection.vue'
import HomeList from './HomeList.vue'
import HomeDetail from './HomeDetail.vue'

export default {
  name: 'HomeContent',
  components: {
    SceneSection,
    HomeList,
    HomeDetail,
  },
  emits: ['go-menu'],
  data() {
    return {
      thumbImg,
      thumbImg1,
      thumbImg2,
      thumbImg3,
      thumbImg4,
      currentSlide: 0,
      carouselList: [],
      timer: null,
      newsList: [],
      noticeList: [],
      industryList: [],
      govList: [],
      consultList: [],
      sceneList: [],
      showDetail: false,
      showList: false,
      listSection: '首页',
      currentArticle: {},
      currentSection: ''
    }
  },
  computed: {
    thumbImages() {
      return [this.thumbImg1, this.thumbImg2, this.thumbImg3, this.thumbImg4]
    },
  },
  watch: {
    showDetail(val) { if (val) this.$nextTick(() => { window.scrollTo(0, 0) }) },
    showList(val) { if (val) this.$nextTick(() => { window.scrollTo(0, 0) }) },
  },
  mounted() {
    this.startAutoPlay()
    this.fetchHomeData()
  },
  beforeDestroy() {
    this.stopAutoPlay()
  },
  methods: {
    async fetchHomeData() {
      try {
        const res = await getHomePage('zh')
        if (res.code !== 200) return
        const d = res.data
        if (d.banners && d.banners.length) {
          this.carouselList = d.banners.map(b => ({
            img: b.coverImage || b.imageUrl,
            title: b.title,
            id: b.id,
            category: b.category,
            linkUrl: b.linkUrl,
          }))
        }
        if (d.updates && d.updates.length) {
          this.newsList = d.updates.slice(0, 8).map(item => ({
            id: item.id, title: item.title, date: (item.publishTime || '').substring(0, 10)
          }))
        }
        if (d.culture && d.culture.length) {
          this.noticeList = d.culture.map(item => ({
            id: item.id, title: item.title, date: (item.publishTime || '').substring(0, 10)
          }))
        }
        const travelData = d.travelGuide || d.travelRoutes
        if (travelData && travelData.length) {
          this.industryList = travelData.map(item => ({
            id: item.id, title: item.title, date: (item.publishTime || '').substring(0, 10)
          }))
        }
        if (d.govPublic && d.govPublic.length) {
          this.govList = d.govPublic.map(item => ({
            id: item.id, title: item.title, desc: item.summary, date: (item.publishTime || '').substring(0, 10)
          }))
        }
        if (d.govInfo && d.govInfo.length) {
          this.consultList = d.govInfo.map(item => ({
            id: item.id, title: item.title, desc: item.summary, date: (item.publishTime || '').substring(0, 10)
          }))
        }
        if (d.config) {
          this.siteConfig = d.config
        }
      } catch (e) {
        console.error('获取首页数据失败:', e)
      }
    },
    async clickBanner() {
      const b = this.carouselList[this.currentSlide]
      if (!b) return
      if (b.linkUrl) {
        window.open(b.linkUrl, '_blank')
        return
      }
      if (b.id) {
        try {
          const res = await getArticleDetail(b.id)
          if (res.code === 200 && res.data) {
            this.currentArticle = { id: b.id, title: b.title, ...res.data }
            this.currentSection = ''
            this.showDetail = true
          }
        } catch (e) {
          console.error('获取详情失败:', e)
        }
      }
    },
    goArticle(section, item) {
      if (section === '景区动态') {
        this.$emit('go-menu', { menu: 2, article: item })
        return
      }
      if (section === '政务公开' || section === '政务信息') {
        this.$emit('go-menu', { menu: 3, article: item, section })
        return
      }
      if (section === '景区文化' || section === '景区风光') {
        this.$emit('go-menu', { menu: 1, article: item, section })
        return
      }
      if (section === '旅游攻略') {
        this.$emit('go-menu', { menu: 4, article: item })
        return
      }
      this.currentSection = section
      this.currentArticle = item
      this.showDetail = true
    },
    openSection(section) {
      const menuMap = { '景区动态': 2, '旅游攻略': 4, '政务公开': 3, '政务信息': 3, '景区文化': 1, '景区风光': 1 }
      if (menuMap[section] !== undefined) {
        this.$emit('go-menu', { menu: menuMap[section], section })
        return
      }
      this.listSection = section
      this.showList = true
    },
    openArticleFromList(sideIndex, item) {
      const sectionMap = ['景区动态', '景区文化', '旅游攻略', '政务公开', '政务信息', '景区风光']
      this.currentSection = sectionMap[sideIndex]
      this.currentArticle = item
      this.showList = false
      this.showDetail = true
    },
    backToList(section) {
      this.listSection = section
      this.showDetail = false
      this.showList = true
    },
    onNextArticle(article) {
      this.currentArticle = article
    },
    thumbClick(i) {
      if (i === 0 || i === 1) {
        this.$emit('go-menu', { menu: 4 })
      } else if (i === 2) {
        const url = this.siteConfig.vr_tour_url || this.siteConfig.vrTourUrl || 'http://www.0518720.com/tour/e4aed3f96c9359f3'
        if (url) window.open(url, '_blank')
      } else if (i === 3) {
        this.$emit('go-menu', { menu: 5 })
      }
    },
    goVr() {
      const url = this.siteConfig.vr_tour_url || this.siteConfig.vrTourUrl || 'http://www.0518720.com/tour/e4aed3f96c9359f3'
      if (url) window.open(url, '_blank')
    },
    goAudioGuide() {
      this.$emit('go-menu', { menu: 5 })
    },
    startAutoPlay() {
      this.timer = setInterval(() => {
        if (!this.carouselList.length) return
        this.currentSlide = (this.currentSlide + 1) % this.carouselList.length
      }, 3000)
    },
    stopAutoPlay() {
      clearInterval(this.timer)
    },
  },
}
</script>

<style scoped lang="less">
  .home-content{
    margin-top: 0.2rem;
  }
  .carousel-section{
    display: flex;
    align-items: flex-start;
    margin-top: 0.1rem;
    width: 100%;
    gap: 0.1rem;
    .carousel{
      flex: 1;
      .carousel-inner{
        position: relative;
        width: 100%;
        height: 4.44rem;
        overflow: hidden;
        cursor: pointer;
        img{
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .carousel-bar{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 0.51rem;
        background: rgba(0,0,0,.5);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 0.15rem;
        .carousel-title{
          color: #fff;
          font-size: 0.24rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          flex: 1;
          margin-right: 0.15rem;
        }
        .carousel-dots{
          display: flex;
          align-items: center;
          flex-shrink: 0;
          .dot{
            width: 0.14rem;
            height: 0.14rem;
            border-radius: 50%;
            background: #fff;
            margin-left: 0.12rem;
            cursor: pointer;
            &.active{
              background: #369BF8;
            }
          }
        }
      }
    }
    .carousel-right{
      flex: 1;
      min-width: 0;
      overflow: hidden;
      .section{
        .news-featured{
          font-size: 0.32rem;
          color: #2C2C2C;
          padding: 0.16rem 0.36rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
          border-bottom: 1px dashed #eee;
          margin-bottom: 0.1rem;
        }
      }
    }
  }
  .thumb-row{
    display: flex;
    gap: 0.1rem;
    margin-top: 0.1rem;
    width: 100%;
    overflow: hidden;
    .thumb-img{
      display: block;
      height: 1.12rem;
      flex: 1;
      min-width: 0;
      object-fit: cover;
      &.clickable{
        cursor: pointer;
        &:hover{ opacity: 0.85; }
      }
    }
  }
  .info-section{
    display: flex;
    gap: 0.1rem;
    margin-top: 0.1rem;
    .info-col{
      flex: 1;
      min-width: 0;
      overflow: hidden;
    }
  }
  .section{
      .section-header{
        height: 0.6rem;
        background: rgba(0,0,0,.05);
        display: flex;
        align-items: center;
        cursor: pointer;
        .section-title{
          height: 0.6rem;
          width: 1.8rem;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.24rem;
          color: #fff;
          background: #369BF8;
        }
        .more-btn{
          margin-left: auto;
          margin-right: 0.2rem;
          font-size: 0.16rem;
          color: #666;
          cursor: pointer;
          &:hover{ color: #369BF8; }
        }
      }
    .feature-img-item{
      display: flex;
      padding: 0.1rem 0.2rem 0.1rem 0;
      cursor: pointer;
      &:hover{ background: rgba(0,0,0,.03); }
      .fi-img{
        width: 2.08rem;
        height: 1.31rem;
        object-fit: cover;
        flex-shrink: 0;
        margin-right: 0.15rem;
      }
      .fi-info{
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .fi-title{
          font-size: 0.24rem;
          color: #2C2C2C;
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .fi-desc{
          font-size: 0.16rem;
          color: #4C4B4B;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          margin: 0.08rem 0;
        }
        .fi-date{
          font-size: 0.19rem;
          color: #989898;
        }
      }
    }
    .news-list{
      .news-item{
        display: flex;
        align-items: center;
        padding: 0.05rem 0.3rem 0.05rem 0;
        cursor: pointer;
        &:hover{
          background: rgba(0,0,0,.03);
        }
        .news-dot{
          width: 0.05rem;
          height: 0.05rem;
          border-radius: 50%;
          background: #0E8064;
          flex-shrink: 0;
          margin-right: 0.05rem;
        }
        .news-title{
          flex: 1;
          min-width: 0;
          font-size: 0.23rem;
          color: #2C2C2C;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-right: 0.2rem;
        }
        .news-date{
          font-size: 0.19rem;
          color: #989898;
          flex-shrink: 0;
        }
      }
    }
  }
</style>
